/**
 * Compara versões do app por partes numéricas ("1.9.0" < "1.12.0").
 * Retorna negativo se a < b, zero se iguais e positivo se a > b.
 */
export const compareVersions = (a: string, b: string): number => {
  const partsA = a.split('.').map(part => parseInt(part, 10) || 0);
  const partsB = b.split('.').map(part => parseInt(part, 10) || 0);
  const length = Math.max(partsA.length, partsB.length);
  for (let i = 0; i < length; i++) {
    const diff = (partsA[i] || 0) - (partsB[i] || 0);
    if (diff !== 0) return diff;
  }
  return 0;
};

/** Versão desconhecida (app que ainda não reporta) conta como anterior. */
export const isBelowVersion = (version: string | null, minVersion: string): boolean =>
  !version || compareVersions(version, minVersion) < 0;
